import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import $ from "jquery";
import { Redirect } from "react-router-dom";

import { singleSignOnOAuth } from "../../../config/client_api_calls";

export default class SsoAuthentication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      successMessage: "",
    };
  }

  pythonDecrypt = (encryptedData, passphrase) => {
    // Decode the URL-safe Base64 back to regular Base64
    const base64Encoded = encryptedData.replace(/-/g, "+").replace(/_/g, "/");

    const jsonString = CryptoJS.enc.Utf8.stringify(
      CryptoJS.enc.Base64.parse(base64Encoded)
    );
    const json = JSON.parse(jsonString);

    const iv = CryptoJS.enc.Base64.parse(json.iv);
    const encrypted = json.data;

    const secretKey = CryptoJS.enc.Hex.parse(passphrase);

    const decrypted = CryptoJS.AES.decrypt(encrypted, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  async componentDidMount() {
    const { reseller_url, token } = this.props.match.params;

    console.log("token", token);
    console.log("reseller_url", reseller_url);

    if (reseller_url === "") {
      this.setState({
        errorMessage: "URL is not valid. Please enter the valid URL.",
      });
    } else {
      const passphrase = process.env.REACT_APP_CARRIER_VOICE_ALERTS_SECRET_KEY;

      let decryptedData;
      try {
        decryptedData = this.pythonDecrypt(token, passphrase);
        console.log("Decrypted data:", decryptedData);
      } catch (error) {
        console.error("Error decrypting token:", error);
        this.setState({
          errorMessage: "Failed to decrypt the token.",
        });
        return;
      }
      let parsedData;
      try {
        parsedData = JSON.parse(decryptedData);
        console.log("Parsed Data:", parsedData);
      } catch (error) {
        console.error("Error parsing decrypted data:", error);
        this.setState({
          errorMessage: "Failed to parse the decrypted token data.",
        });
        return;
      }

      const {
        email,
        username,
        user_type,
        parent_accountno,
        client_id,
        redirect_url,
        return_url,
        service_id
      } = parsedData;

      let apiHit = await singleSignOnOAuth(email, reseller_url, client_id);
      console.log("apiHit.data: ", apiHit.data);
      if (
        apiHit.data.status === 404 &&
        apiHit.data.message === "Invalid or Expired Token."
      ) {
        //window.location.replace("/error");
        this.setState({
          errorMessage: "Invalid credentials or expired token.",
          successMessage: "",
        });
      } else if (
        apiHit.data.status === 200 &&
        apiHit.data.message === "success"
      ) {
        //Remove Previous Session
        Cookies.remove("comp_nme__");
        Cookies.remove("eml__");
        Cookies.remove("acn__");
        Cookies.remove("tkn__");
        Cookies.remove("residentifier__");
        Cookies.remove("restitle__");
        Cookies.remove("ressig__");
        Cookies.remove("restkn__");
        Cookies.remove("resacct__");

        Cookies.remove("client_name__");
        Cookies.remove("client_comp_nme__");
        Cookies.remove("client_eml__");
        Cookies.remove("client_acn__");
        Cookies.remove("client_tkn__");
        Cookies.remove("client_phone__");
        Cookies.remove("client_title__");
        Cookies.remove("client_parent_accountno__");
        Cookies.remove("client_user_type__");
        Cookies.remove("client_adress__");
        Cookies.remove("filer_id__");

        if (return_url && return_url !== "") {
          Cookies.set(
            "client_return_url__",
            CryptoJS.AES.encrypt(
              return_url,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
        }
        Cookies.set(
          "client_name__",
          CryptoJS.AES.encrypt(
            username,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_tkn__",
          CryptoJS.AES.encrypt(
            apiHit.data.token,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_acn__",
          CryptoJS.AES.encrypt(
            client_id,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_eml__",
          CryptoJS.AES.encrypt(
            email,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_comp_nme__",
          CryptoJS.AES.encrypt(
            apiHit.data.comp_name,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_title__",
          CryptoJS.AES.encrypt(
            apiHit.data.title,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_phone__",
          CryptoJS.AES.encrypt(
            apiHit.data.phone,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_adress__",
          CryptoJS.AES.encrypt(
            apiHit.data.address,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_country__",
          CryptoJS.AES.encrypt(
            apiHit.data.country,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_user_type__",
          CryptoJS.AES.encrypt(
            apiHit.data.user_type,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_parent_accountno__",
          CryptoJS.AES.encrypt(
            parent_accountno,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "residentifier__",
          CryptoJS.AES.encrypt(
            apiHit.data.reseller_domain_identifier,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "reslogo__",
          CryptoJS.AES.encrypt(
            apiHit.data.reseller_logo,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "restkn__",
          CryptoJS.AES.encrypt(
            apiHit.data.reseller_hash,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "resacct__",
          CryptoJS.AES.encrypt(
            apiHit.data.reseller_accountno,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );

        Cookies.set(
          "filer_id__",
          CryptoJS.AES.encrypt(
            apiHit.data.filer_id,
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        localStorage.removeItem("activeMenusClient")
        localStorage.removeItem("activeSubmenuItemClient")
        this.setState({
          errorMessage: "",
          successMessage: "Account authenticated successfully.",
        });
        setTimeout(function () {
          if (redirect_url && redirect_url !== "") {
            if (redirect_url === "profile") {
              window.location.replace(
                `/${reseller_url}/client/dashboard?redirect=profile`
              );
            } else if (redirect_url === "add_sub_carrier") {
              window.location.replace(
                `/${reseller_url}/client/SubClients/AddSubClient`
              );
            } else if (redirect_url === "service_buy" && service_id) {
              window.location.replace(`/${reseller_url}/client/EditSalesOrder/${service_id}`);
            } else {
              window.location.replace(
                `/${reseller_url}/client/${redirect_url}`
              );
            }
          } else {
            window.location.replace(`/${reseller_url}/client/dashboard`);
          }
        }, 3000);
      } else {
        this.setState({
          errorMessage:
            "Your account cannot be authenticated this time. Please check the URL or try again later.",
          successMessage: "",
        });
      }
    }
  }

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {this.state.errorMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                      <h4>Error</h4>
                      <p>{this.state.errorMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}

              {this.state.successMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-success">
                    <div className="alert-text">
                      <h4>Success</h4>
                      <p>{this.state.successMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="text-center" style={{ marginTop: "20%" }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
